import { addLocaleData } from "react-intl";

import { localeData, isRtl } from "scratch-l10n";
// 只导入需要的两种语言：English 和中文简体
import editorMessages from "scratch-l10n/locales/editor-msgs";

// 过滤只保留需要的语言
const filteredMessages = {
    en: editorMessages.en,
    "zh-cn": editorMessages["zh-cn"]
};

// 英文翻译
if (filteredMessages["en"]) {
    Object.assign(filteredMessages["en"], {
        // 原始自定义积木
        "gui.opcodeLabels.goBack": "Go Back",
        "gui.opcodeLabels.dance": "Dance",
        // "gui.opcodeLabels.motion_moveleft": "Move Left %1 %2 steps",
        // "gui.opcodeLabels.motion_moveright": "Move Right %1 %2 steps",
        "gui.opcodeLabels.motion_forward": "Forward %1 steps",
        "gui.opcodeLabels.motion_goback": "Backward %1 steps",
        "gui.opcodeLabels.motion_gotoxyz": "Go to X: %1 Y: %2 Z: %3",
        "gui.opcodeLabels.motion_stop": "Delay %1 seconds",
        "gui.opcodeLabels.motion_speed": "Set Speed %1",
        
        // 新增积木-2026.04.18
        "gui.opcodeLabels.motion_start_line_tracking": "Start Line Tracking",
        "gui.opcodeLabels.motion_stop_line_tracking": "Stop Line Tracking",
        
        // 新增积木-2026.04.18
        "gui.opcodeLabels.motion_advance": "Advance",
        "gui.opcodeLabels.motion_backward": "Backward",
        "gui.opcodeLabels.motion_turn_left": "Turn Left",
        "gui.opcodeLabels.motion_turn_right": "Turn Right",
        "gui.opcodeLabels.motion_stop_move": "Stop Move",
        "gui.opcodeLabels.looks_show_text": "Show Text %1 for %2 seconds",
        "gui.opcodeLabels.looks_show_expression": "Show Expression %1",
        "gui.opcodeLabels.looks_show_image": "Show Image %1",
        "gui.opcodeLabels.looks_screen_clear": "Clear Screen",
        "gui.opcodeLabels.sounds_play": "Play Voice %1",
        // 机器狗积木
        "gui.opcodeLabels.control_servo_reset": "Reset Stand",
        "gui.opcodeLabels.motion_nod": "Nod",
        "gui.opcodeLabels.motion_sway_x": "Sway Front-Back",
        "gui.opcodeLabels.motion_sway_y": "Sway Left-Right",
        "gui.opcodeLabels.motion_fall": "Fall Down",
        "gui.opcodeLabels.motion_retract_leg": "Retract Leg",
        "gui.opcodeLabels.motion_handshake": "Handshake",
        "gui.opcodeLabels.motion_stretch": "Stretch",
        "gui.opcodeLabels.motion_jump": "Jump Forward",
        "gui.opcodeLabels.self_dog_move_control": "Bark",
        // 显示积木
        "gui.opcodeLabels.looks_set_rgb": "Light: Index %1 Color %2",
        "gui.opcodeLabels.looks_turn_on_all_lights": "Turn On All Lights %1",
        "gui.opcodeLabels.looks_turn_off_all_lights": "Turn Off All Lights",
        // "gui.opcodeLabels.looks_show_text_duration": "Show %1 for %2 seconds",
        // 图像识别积木
        "gui.opcodeLabels.image_identify_object": "Identify %1 is %2",
        "gui.opcodeLabels.image_identify_object_if": "If %1",
        "gui.opcodeLabels.image_identify_object_else": "Else",
        "gui.opcodeLabels.shape": "Shape",
        "gui.opcodeLabels.object": "Object",
        "gui.opcodeLabels.color": "Color",
        "gui.opcodeLabels.gesture": "Gesture",
        // 事件积木
        "gui.opcodeLabels.event_delay": "Wait %1 seconds",
        "gui.opcodeLabels.event_repeat": "Repeat %1 times",
        "gui.opcodeLabels.event_gyro": "When gyroscope %1 %2°",
        "gui.opcodeLabels.greater": "Greater",
        "gui.opcodeLabels.less": "Less",
        "gui.opcodeLabels.equal": "Equal",
        "gui.opcodeLabels.event_detect_cliff": "Forward until cliff detected",
        "gui.opcodeLabels.event_back_detect_cliff": "Backward until cliff detected",
        "gui.opcodeLabels.event_button_pressed": "When %1 button pressed",
        "gui.opcodeLabels.left_button": "Left",
        "gui.opcodeLabels.right_button": "Right",
        "gui.opcodeLabels.event_if_button": "If %1 button pressed then",
        "gui.opcodeLabels.else": "Else",
        "gui.opcodeLabels.event_and_or": "%1 %2 %3",
        "gui.opcodeLabels.and": "AND",
        "gui.opcodeLabels.or": "OR",
        "gui.opcodeLabels.event_left_line_sensor": "Left line sensor value",
        "gui.opcodeLabels.event_right_line_sensor": "Right line sensor value",
        "gui.opcodeLabels.event_gyro_value": "Gyroscope value",
        "gui.opcodeLabels.event_compare": "%1 %2 %3",
        "gui.opcodeLabels.greater_than": ">",
        "gui.opcodeLabels.equal_to": "=",
        "gui.opcodeLabels.less_than": "<",
        // 新增积木
        "gui.opcodeLabels.event_if_else": "If %1 then",
        "gui.opcodeLabels.else_label": "Else",
        "gui.opcodeLabels.event_repeat_condition": "Repeat %1 %2",
        "gui.opcodeLabels.satisfy": "satisfy condition",
        "gui.opcodeLabels.unsatisfy": "unsatisfy condition",
        // "gui.opcodeLabels.event_break_loop": "Break loop",
        "gui.opcodeLabels.event_gyro_reset": "Reset gyroscope",
        // 定时积木
        "gui.opcodeLabels.event_interval": "Every %1 seconds, execute %2 times",
        // 系统积木
        "gui.opcodeLabels.sys_set_volume": "Set Volume %1",
        "gui.opcodeLabels.sys_reboot": "Reboot",
        "gui.opcodeLabels.looks_theme": "Switch Theme %1",
        "gui.opcodeLabels.dark": "Dark",
        "gui.opcodeLabels.light": "Light",
        // 默认文本
        "gui.opcodeLabels.text_default": "Text",
        // 积木分类名称 - 用于 ScratchMsgs.translate
        "CATEGORY_DISPLAY": "Display",
        "CATEGORY_VOICE": "Voice",
        "CATEGORY_IMAGE": "Image",
        "CATEGORY_EVENT_CUSTOM": "Event",
        "CATEGORY_TIMING": "Timing",
        "CATEGORY_SYSTEM": "System",
        "DEFAULT_TEXT": "Text",
        "SHAPE": "Shape",
        // 菜单栏
        "gui.menuBar.home": "Home",
        "gui.menuBar.course": "Course Platform",
        "gui.menuBar.settings": "Settings",
        "gui.menuBar.agentManage": "Agent/Device",
        "gui.menuBar.colorMode": "Color Mode",
        // DeviceMenu
        "gui.deviceMenu.connectedDevice": "Connected Device：",
        "gui.deviceMenu.selectDevicePlaceholder": "Please select a connected device",
        "gui.deviceMenu.refreshTooltip": "Refresh device list",
        "gui.deviceMenu.refreshSuccess": "Device refresh successful",
        "gui.deviceMenu.unknownDevice": "Unknown Device",
        "gui.SpriteInfo.spritePlaceholder": "Sprite",
        // AgentManage
        "gui.agentManage.title": "Agent Management",
        "gui.agentManage.descriptionTitle": "Description:",
        "gui.agentManage.description1": "1. Users can choose to use the default agent to bind devices or add new agents to bind devices",
        "gui.agentManage.description2": "2. Users can create new agents and edit agent information and device bindings",
        "gui.agentManage.addAgent": "Add Agent",
        // CreateAgentModal
        "gui.agentManage.createAgent": "Create Agent",
        "gui.agentManage.confirm": "Confirm",
        "gui.agentManage.cancel": "Cancel",
        "gui.agentManage.agentNameLabel": "Agent Name:",
        "gui.agentManage.agentNamePlaceholder": "Please enter agent name",
        "gui.agentManage.creating": "Creating...",
        "gui.agentManage.addSuccess": "Added successfully",
        // ComponentList
        "gui.agentManage.noConversation": "No conversation yet",
        "gui.agentManage.justNow": "Just now",
        "gui.agentManage.minutesAgo": "{minutes} minutes ago",
        "gui.agentManage.hoursAgo": "{hours} hours ago",
        "gui.agentManage.hoursMinutesAgo": "{hours} hours {minutes} minutes ago",
        "gui.agentManage.confirmDelete": "Are you sure you want to delete this agent?",
        "gui.agentManage.deleting": "Deleting...",
        "gui.agentManage.deleteSuccess": "Deleted successfully!",
        "gui.agentManage.deleteFailed": "Delete failed!",
        "gui.agentManage.autoUpdateEnabled": "Auto update enabled",
        "gui.agentManage.autoUpdateDisabled": "Auto update disabled",
        "gui.agentManage.operationFailed": "Operation failed",
        "gui.agentManage.llmModel": "LLM Model:",
        "gui.agentManage.ttsModel": "TTS Model:",
        "gui.agentManage.configRole": "Config Role",
        "gui.agentManage.deviceManagement": "Device Management",
        "gui.agentManage.chatHistory": "Chat History",
        "gui.agentManage.enableMemoryFirst": "Please enable memory in 'Config Role' first",
        "gui.agentManage.recentConversation": "Recent conversation: {time}",
        "gui.agentManage.view": "View",
        "gui.agentManage.createTime": "Create Time: {time}",
        "gui.agentManage.updateTime": "Update Time: {time}",
        // GUI 页面
        "gui.gui.noBlocks": "No blocks",
        "gui.gui.blocksInDevelopment": "Other blocks are under development",
        "gui.gui.pleaseSelectDevice": "Please select a device first",
        "gui.gui.messageSentSuccess": "Message sent successfully",
        "gui.gui.messageSentFailed": "Failed to send message",
        "gui.gui.runToHardware.line1": "Run to",
        "gui.gui.runToHardware.line2": "Hardware",
        // FunctionManagementDrawer
        "gui.agentManage.functionManagement": "Function Management",
        "gui.agentManage.unselectedFunctions": "Unselected Functions",
        "gui.agentManage.selectedFunctions": "Selected Functions",
        "gui.agentManage.functionName": "Function Name",
        "gui.agentManage.functionDescription": "Description",
        "gui.agentManage.noDescription": "No description",
        "gui.agentManage.searchPlaceholder": "Search function name",
        "gui.agentManage.loadFailed": "Failed to load",
        "gui.agentManage.updateSuccess": "Update successful",
        "gui.agentManage.updateFailed": "Update failed",
        // DeviceModal
        "gui.agentManage.deviceManagementTitle": "Device Management",
        "gui.agentManage.remark": "Remark",
        "gui.agentManage.deviceModel": "Device Model",
        "gui.agentManage.firmwareVersion": "Firmware Version",
        "gui.agentManage.macAddress": "Mac Address",
        "gui.agentManage.bindTime": "Bind Time",
        "gui.agentManage.lastConversation": "Last Conversation",
        "gui.agentManage.otaUpgrade": "OTA Upgrade",
        "gui.agentManage.operation": "Operation",
        "gui.agentManage.unbind": "Unbind",
        "gui.agentManage.addDevice": "Add Device",
        "gui.agentManage.unbindConfirm": "Are you sure to unbind this device?",
        "gui.agentManage.unbindSuccess": "Unbind successful",
        "gui.agentManage.unbindFailed": "Unbind failed",
        "gui.agentManage.bindSuccess": "Bind successful",
        "gui.agentManage.bindFailed": "Bind failed",
        "gui.agentManage.pleaseSelectDevice": "Please select a device",
        "gui.agentManage.selectDeviceModel": "Please select device model",
        "gui.agentManage.pleaseSelectDeviceModel": "Please select device model!",
        "gui.agentManage.refresh": "Refresh",
        "gui.agentManage.deviceSelectPlaceholder": "Please select device",
        // ChatRecordModal
        "gui.agentManage.chatHistoryTitle": "Chat History",
        "gui.agentManage.user": "User",
        "gui.agentManage.assistant": "Assistant",
        "gui.agentManage.close": "Close",
        "gui.agentManage.loadingChatHistory": "Loading chat history...",
        "gui.agentManage.loadMore": "Load More",
        "gui.agentManage.noMore": "No more~",
        "gui.agentManage.agent": "Agent",
        "gui.agentManage.device": "Device",
        "gui.agentManage.chatDetail": "Chat Detail",
        "gui.agentManage.noChatData": "No chat data",
        "gui.agentManage.todayTime": "Today {hours}:{minutes}",
        "gui.agentManage.yesterdayTime": "Yesterday {hours}:{minutes}",
        "gui.agentManage.noConversation": "No conversation yet",
        "gui.agentManage.justNow": "Just now",
        "gui.agentManage.minutesAgo": "{minutes} minutes ago",
        "gui.agentManage.hoursMinutesAgo": "{hours} hours {minutes} minutes ago",
        "gui.agentManage.hoursAgo": "{hours} hours ago",
        "gui.agentManage.confirmDelete": "Are you sure you want to delete this agent?",
        "gui.agentManage.deleting": "Deleting...",
        "gui.agentManage.deleteSuccess": "Deleted successfully!",
        "gui.agentManage.deleteFailed": "Delete failed!",
        "gui.agentManage.autoUpdateEnabled": "Auto update enabled",
        "gui.agentManage.autoUpdateDisabled": "Auto update disabled",
        "gui.agentManage.operationFailed": "Operation failed",
        "gui.agentManage.llmModel": "LLM Model:",
        "gui.agentManage.ttsModel": "TTS Model:",
        "gui.agentManage.configRole": "Config Role",
        "gui.agentManage.deviceManagement": "Device Management({count})",
        "gui.agentManage.enableMemoryFirst": "Please enable memory in 'Config Role' first",
        "gui.agentManage.chatHistory": "Chat History",
        "gui.agentManage.recentConversation": "Recent conversation: {time}",
        "gui.agentManage.view": "View",
        "gui.agentManage.createTime": "Create Time: {time}",
        "gui.agentManage.updateTime": "Update Time: {time}",
        "gui.agentManage.remarkUpdateSuccess": "Remark updated successfully",
        "gui.agentManage.remarkUpdateFailed": "Failed to update remark",
        "gui.agentManage.teacherBind": "Teacher Bind",
        "gui.agentManage.getFirmwareTypeFailed": "Failed to get firmware type",
        "gui.agentManage.unbinding": "Unbinding...",
        "gui.agentManage.batchUnbindSuccess": "Successfully unbound {count} devices",
        "gui.agentManage.batchUnbindError": "Error occurred during batch unbind",
        "gui.agentManage.selectDeviceToUnbind": "Please select devices to unbind",
        "gui.agentManage.confirmBatchUnbind": "Are you sure you want to unbind the selected {count} devices?",
        "gui.agentManage.confirmUnbindDevice": "Are you sure you want to unbind device \"{name}\"?",
        "gui.agentManage.deviceUnbindSuccess": "Device unbound successfully",
        "gui.agentManage.deviceUnbindFailed": "Failed to unbind device",
        "gui.agentManage.getDeviceListFailed": "Failed to get device list",
        "gui.agentManage.updating": "Updating...",
        "gui.agentManage.adding": "Adding...",
        "gui.agentManage.deviceAddSuccess": "Device added successfully",
        "gui.agentManage.addFailed": "Add failed",
        "gui.agentManage.enter6DigitCode": "Please enter 6-digit verification code",
        "gui.agentManage.deviceBindSuccess": "Device bound successfully",
        "gui.agentManage.noData": "No data",
        "gui.agentManage.verificationBind": "Verification Bind",
        "gui.agentManage.manualAdd": "Manual Add",
        "gui.agentManage.manualAddDevice": "Manual Add Device",
        "gui.agentManage.enterFirmwareVersion": "Please enter firmware version",
        "gui.agentManage.macAddressFormat": "Please enter correct Mac address format, e.g.: 00:1A:2B:3C:4D:5E",
        "gui.agentManage.enterMacAddress": "Please enter Mac address",
        "gui.agentManage.verificationCode": "Verification Code",
        "gui.agentManage.enterVerificationCode": "Please enter verification code!",
        "gui.agentManage.getPluginListFailed": "Failed to get plugin list",
        "gui.agentManage.getTemplateListFailed": "Failed to get template list",
        "gui.agentManage.getModelListFailed": "Failed to get model list",
        "gui.agentManage.getLlmModelListFailed": "Failed to get LLM model list",
        "gui.agentManage.getConfigFailed": "Failed to get configuration",
        "gui.agentManage.templateApplied": "「{name}」template applied",
        "gui.agentManage.confirmReset": "Are you sure you want to reset the configuration?",
        "gui.agentManage.configSaveSuccess": "Configuration saved successfully",
        "gui.agentManage.configSaveFailed": "Failed to save configuration",
        "gui.agentManage.configReset": "Configuration reset",
        "gui.agentManage.roleVoice": "Role Voice:",
        "gui.agentManage.voiceDescription": "Role voice refers to the specific speaker voice that different platforms can support, including male voice, female voice, child voice, etc.",
        // DynamicFormFields
        "gui.agentManage.pleaseEnter": "Please enter",
        "gui.agentManage.pleaseSelect": "Please select",
        "gui.agentManage.requiredField": "This field is required",
        "gui.agentManage.invalidFormat": "Invalid format",
        "gui.agentManage.addItem": "Add Item",
        "gui.agentManage.remove": "Remove",
        // AIConfigModal & AIConfigContent
        "gui.agentManage.aiConfig": "AI Configuration",
        "gui.agentManage.vad": "Voice Activity Detection(VAD)",
        "gui.agentManage.asr": "Automatic Speech Recognition(ASR)",
        "gui.agentManage.llm": "Large Language Model(LLM)",
        "gui.agentManage.tts": "Text to Speech(TTS)",
        "gui.agentManage.memory": "Memory",
        "gui.agentManage.noMemory": "No Memory",
        "gui.agentManage.roleSetting": "Role Setting",
        "gui.agentManage.systemPrompt": "System Prompt",
        "gui.agentManage.save": "Save",
        "gui.agentManage.saving": "Saving...",
        "gui.agentManage.saveSuccess": "Save successful",
        "gui.agentManage.saveFailed": "Save failed",
        "gui.agentManage.loadConfigFailed": "Failed to load configuration",
        "gui.agentManage.selectModel": "Please select model",
        "gui.agentManage.configDescription": "Configure AI model parameters and role settings",
        "gui.agentManage.noToolsAvailable": "No tools available",
        "gui.agentManage.pleaseEnterFirmwareVersion": "Please enter firmware version!",
        "gui.agentManage.pleaseEnterMacAddress": "Please enter Mac address!",
        "gui.agentManage.macAddressRequired": "Please enter Mac address",
        // AI Configuration
        "gui.agentManage.vllm": "Vision Large Language Model(VLLM)",
        "gui.agentManage.intent": "Intent Recognition(Intent)",
        "gui.agentManage.restartNotice": "After saving the configuration, you need to restart the device for the new configuration to take effect.",
        "gui.agentManage.roleConfig": "Role Configuration",
        "gui.agentManage.saveConfig": "Save Configuration",
        "gui.agentManage.reset": "Reset",
        "gui.agentManage.roleNickname": "Role Nickname:",
        "gui.agentManage.roleTemplate": "Role Template:",
        "gui.agentManage.roleDescription": "Role Description:",
        "gui.agentManage.shortTermMemory": "Dialogue Short-term Memory:",
        // Additional AI Configuration Fields
        "gui.agentManage.reportText": "Report Text",
        "gui.agentManage.reportTextVoice": "Report Voice",
        "gui.agentManage.memoryRecommend": "Memory Recommend",
        "gui.agentManage.ttsDescription": "Text to Speech (TTS)",
        "gui.agentManage.confirmResetForm": "Are you sure you want to reset the form?",
        "gui.agentManage.teacherRole": "Teacher",
        "gui.agentManage.teacherNote1": "Note: Teachers need to view and unbind devices already bound to students in the class",
        "gui.agentManage.teacherNote2": "Note: Devices assigned by teachers cannot be unbound or edited",
        "gui.agentManage.getFirmwareTypeError": "Failed to get firmware type:",
        // Custom Fields - Image Upload
        "gui.customFields.uploaded": "Uploaded",
        "gui.customFields.uploadImage": "Upload Image",
        "gui.customFields.invalidFileType": "Please select a valid image file",
        "gui.customFields.fileTooLarge": "File size cannot exceed 500KB\nCurrent size: {size}KB\nPlease select a smaller image",
        "gui.customFields.uploadFailed": "Upload failed",
        "gui.customFields.uploadError": "Image upload failed: {error}",
        "gui.customFields.uploadRetry": "Image upload failed, please try again",
    });
}

if (filteredMessages["zh-cn"]) {
    Object.assign(filteredMessages["zh-cn"], {
        "gui.opcodeLabels.goBack": "后退一步",
        "gui.opcodeLabels.dance": "跳个舞",
        // "gui.opcodeLabels.motion_moveleft": `左移 %1 %2 步`,
        // "gui.opcodeLabels.motion_moveright": `右移 %1 %2 步`,

        "gui.opcodeLabels.motion_forward": "前进 %1 步",
        "gui.opcodeLabels.motion_goback": "后退 %1 步",
        "gui.opcodeLabels.motion_gotoxyz": `移到 X: %1 Y: %2 Z: %3`,
        "gui.opcodeLabels.motion_stop": "延时 %1 秒",
        "gui.opcodeLabels.motion_speed": "设置速度 %1",
                
        // 新增积木-2026.04.18
        "gui.opcodeLabels.motion_start_line_tracking": "开始巡线",
        "gui.opcodeLabels.motion_stop_line_tracking": "停止巡线",
        
        // 新增积木-2026.04.18
        "gui.opcodeLabels.motion_advance": "前进",
        "gui.opcodeLabels.motion_backward": "后退",
        "gui.opcodeLabels.motion_turn_left": "左转",
        "gui.opcodeLabels.motion_turn_right": "右转",
        "gui.opcodeLabels.motion_stop_move": "停止移动",
        "gui.opcodeLabels.looks_show_text": "显示文字 %1 显示时长 %2 秒",
        "gui.opcodeLabels.looks_show_expression": "显示表情 %1",
        "gui.opcodeLabels.looks_show_image": "显示图片 %1",
        "gui.opcodeLabels.looks_screen_clear": "清空屏幕",
        "gui.menuBar.home": "首页",
        "gui.menuBar.course": "课程平台",
        "gui.menuBar.settings": "设置",
        "gui.menuBar.agentManage": "智能体/设备管理",
        "gui.opcodeLabels.sounds_play": "播放语音 %1",
        "gui.menuBar.colorMode": "颜色模式",
        "gui.deviceMenu.connectedDevice": "已连接的设备：",
        "gui.deviceMenu.selectDevicePlaceholder": "请选择连接的设备",
        "gui.deviceMenu.refreshTooltip": "刷新设备列表",
        "gui.deviceMenu.refreshSuccess": "设备刷新成功",
        "gui.deviceMenu.unknownDevice": "未知设备",
        "gui.SpriteInfo.spritePlaceholder": "角色",
        "gui.agentManage.title": "智能体管理",
        "gui.agentManage.descriptionTitle": "说明：",
        "gui.agentManage.description1": "1、用户可以选择使用默认的智能体绑定设备也可以自行添加新的智能体进行设备绑定",
        "gui.agentManage.description2": "2、用户可以新建智能体并编辑智能体信息和设备绑定",
        "gui.agentManage.addAgent": "添加智能体",
        // CreateAgentModal
        "gui.agentManage.createAgent": "新建智能体",
        "gui.agentManage.confirm": "确定",
        "gui.agentManage.cancel": "取消",
        "gui.agentManage.agentNameLabel": "智能体名称：",
        "gui.agentManage.agentNamePlaceholder": "请输入智能体名称",
        "gui.agentManage.creating": "创建中...",
        "gui.agentManage.addSuccess": "添加成功",
        // ComponentList
        "gui.agentManage.noConversation": "暂未对话",
        "gui.agentManage.justNow": "刚刚",
        "gui.agentManage.minutesAgo": "{minutes}分钟前",
        "gui.agentManage.hoursAgo": "{hours}小时前",
        "gui.agentManage.hoursMinutesAgo": "{hours}小时{minutes}分钟前",
        "gui.agentManage.confirmDelete": "是否删除该智能体？",
        "gui.agentManage.deleting": "删除中...",
        "gui.agentManage.deleteSuccess": "删除成功！",
        "gui.agentManage.deleteFailed": "删除失败！",
        "gui.agentManage.autoUpdateEnabled": "已设置成自动升级",
        "gui.agentManage.autoUpdateDisabled": "已关闭自动升级",
        "gui.agentManage.operationFailed": "操作失败",
        "gui.agentManage.llmModel": "语言模型:",
        "gui.agentManage.ttsModel": "音色模型:",
        "gui.agentManage.configRole": "配置角色",
        "gui.agentManage.deviceManagement": "设备管理",
        "gui.agentManage.chatHistory": "聊天记录",
        "gui.agentManage.enableMemoryFirst": "请先在「配置角色」界面开启记忆",
        "gui.agentManage.recentConversation": "最近对话: {time}",
        "gui.agentManage.view": "查看",
        "gui.agentManage.createTime": "创建时间: {time}",
        "gui.agentManage.updateTime": "更新时间: {time}",
        // 机器狗积木
        "gui.opcodeLabels.control_servo_reset": "复位站立",
        "gui.opcodeLabels.motion_nod": "点个头",
        "gui.opcodeLabels.motion_sway_x": "前后摇摆",
        "gui.opcodeLabels.motion_sway_y": "左右摇摆",
        "gui.opcodeLabels.motion_fall": "趴一下",
        "gui.opcodeLabels.motion_retract_leg": "收回腿部",
        "gui.opcodeLabels.motion_handshake": "握个手",
        "gui.opcodeLabels.motion_stretch": "伸个懒腰",
        "gui.opcodeLabels.motion_jump": "向前跳跃",
        "gui.opcodeLabels.self_dog_move_control": "汪汪汪发声",
        // 显示积木
        "gui.opcodeLabels.looks_set_rgb": "打开灯光：编号%1 颜色%2",
        "gui.opcodeLabels.looks_turn_on_all_lights": "打开所有灯光 %1",
        "gui.opcodeLabels.looks_turn_off_all_lights": "关闭所有灯光",
        // "gui.opcodeLabels.looks_show_text_duration": "显示%1时长%2秒",
        // 图像识别积木
        "gui.opcodeLabels.image_identify_object": "如果识别 %1 是 %2",
        "gui.opcodeLabels.image_identify_object_if": "如果 %1",
        "gui.opcodeLabels.image_identify_object_else": "否则",
        "gui.opcodeLabels.shape": "形状",
        "gui.opcodeLabels.object": "物体",
        "gui.opcodeLabels.color": "颜色",
        "gui.opcodeLabels.gesture": "手势",
        // 事件积木
        "gui.opcodeLabels.event_delay": "等待 %1 秒",
        "gui.opcodeLabels.event_repeat": "重复执行 %1次",
        "gui.opcodeLabels.event_gyro": "当陀螺仪 %1 %2° 执行",
        "gui.opcodeLabels.greater": "大于",
        "gui.opcodeLabels.less": "小于",
        "gui.opcodeLabels.equal": "等于",
        "gui.opcodeLabels.event_detect_cliff": "前进至检测到有悬崖",
        "gui.opcodeLabels.event_back_detect_cliff": "后退至检测到有悬崖",
        "gui.opcodeLabels.event_button_pressed": "当 %1 键按下",
        "gui.opcodeLabels.left_button": "左边",
        "gui.opcodeLabels.right_button": "右边",
        "gui.opcodeLabels.event_if_button": "如果 %1 键按下 那么",
        "gui.opcodeLabels.else": "否则",
        "gui.opcodeLabels.event_and_or": "%1 %2 %3",
        "gui.opcodeLabels.and": "且",
        "gui.opcodeLabels.or": "或",
        "gui.opcodeLabels.event_left_line_sensor": "左循迹传感器的值",
        "gui.opcodeLabels.event_right_line_sensor": "右循迹传感器的值",
        "gui.opcodeLabels.event_gyro_value": "陀螺仪的值",
        "gui.opcodeLabels.event_compare": "%1 %2 %3",
        "gui.opcodeLabels.greater_than": ">",
        "gui.opcodeLabels.equal_to": "=",
        "gui.opcodeLabels.less_than": "<",
        // 新增积木
        "gui.opcodeLabels.event_if_else": "如果 %1 那么",
        "gui.opcodeLabels.else_label": "否则",
        "gui.opcodeLabels.event_repeat_condition": "重复 %1 %2",
        "gui.opcodeLabels.satisfy": "满足条件",
        "gui.opcodeLabels.unsatisfy": "不满足条件",
        // "gui.opcodeLabels.event_break_loop": "跳出循环",
        "gui.opcodeLabels.event_gyro_reset": "陀螺仪清零",
        // 定时积木
        "gui.opcodeLabels.event_interval": "每隔 %1 秒执行，总执行 %2 次",
        // 系统积木
        "gui.opcodeLabels.sys_set_volume": "音量设置 %1",
        "gui.opcodeLabels.sys_reboot": "重启",
        "gui.opcodeLabels.looks_theme": "切换主题 %1",
        "gui.opcodeLabels.dark": "暗色",
        "gui.opcodeLabels.light": "亮色",
        // 默认文本
        "gui.opcodeLabels.text_default": "文字",
        // 积木分类名称 - 用于 ScratchMsgs.translate
        "CATEGORY_DISPLAY": "显示",
        "CATEGORY_VOICE": "语音",
        "CATEGORY_IMAGE": "图像",
        "CATEGORY_EVENT_CUSTOM": "事件",
        "CATEGORY_TIMING": "定时",
        "CATEGORY_SYSTEM": "系统",
        "DEFAULT_TEXT": "文字",
        "SHAPE": "形状",
        // GUI 页面
        "gui.gui.noBlocks": "没有积木",
        "gui.gui.blocksInDevelopment": "其他积木开发中",
        "gui.gui.pleaseSelectDevice": "请先选择设备",
        "gui.gui.messageSentSuccess": "消息发送成功",
        "gui.gui.messageSentFailed": "消息发送失败",
        "gui.gui.runToHardware.line1": "运行到",
        "gui.gui.runToHardware.line2": "硬件",
        // FunctionManagementDrawer
        "gui.agentManage.functionManagement": "功能管理",
        "gui.agentManage.unselectedFunctions": "未选择的功能",
        "gui.agentManage.selectedFunctions": "已选择的功能",
        "gui.agentManage.functionName": "功能名称",
        "gui.agentManage.functionDescription": "功能描述",
        "gui.agentManage.noDescription": "暂无描述",
        "gui.agentManage.searchPlaceholder": "搜索功能名称",
        "gui.agentManage.loadFailed": "加载失败",
        "gui.agentManage.updateSuccess": "更新成功",
        "gui.agentManage.updateFailed": "更新失败",
        // DeviceModal
        "gui.agentManage.deviceManagementTitle": "设备管理",
        "gui.agentManage.remark": "备注",
        "gui.agentManage.deviceModel": "设备型号",
        "gui.agentManage.firmwareVersion": "固件版本",
        "gui.agentManage.macAddress": "Mac 地址",
        "gui.agentManage.bindTime": "绑定时间",
        "gui.agentManage.lastConversation": "最后对话",
        "gui.agentManage.otaUpgrade": "OTA升级",
        "gui.agentManage.operation": "操作",
        "gui.agentManage.unbind": "解绑",
        "gui.agentManage.addDevice": "添加设备",
        "gui.agentManage.unbindConfirm": "确定解绑该设备吗？",
        "gui.agentManage.unbindSuccess": "解绑成功",
        "gui.agentManage.unbindFailed": "解绑失败",
        "gui.agentManage.bindSuccess": "绑定成功",
        "gui.agentManage.bindFailed": "绑定失败",
        "gui.agentManage.pleaseSelectDevice": "请选择设备",
        "gui.agentManage.selectDeviceModel": "请选择设备型号",
        "gui.agentManage.pleaseSelectDeviceModel": "请选择设备型号！",
        "gui.agentManage.refresh": "刷新",
        "gui.agentManage.deviceSelectPlaceholder": "请选择设备",
        // ChatRecordModal
        "gui.agentManage.chatHistoryTitle": "聊天记录",
        "gui.agentManage.user": "用户",
        "gui.agentManage.assistant": "助手",
        "gui.agentManage.close": "关闭",
        "gui.agentManage.loadingChatHistory": "加载聊天历史...",
        "gui.agentManage.loadMore": "加载更多",
        "gui.agentManage.noMore": "没有更多了~",
        "gui.agentManage.agent": "智能体",
        "gui.agentManage.device": "设备",
        "gui.agentManage.chatDetail": "聊天详情",
        "gui.agentManage.noChatData": "暂无聊天数据",
        "gui.agentManage.todayTime": "今天 {hours}:{minutes}",
        "gui.agentManage.yesterdayTime": "昨天 {hours}:{minutes}",
        "gui.agentManage.noConversation": "暂无对话",
        "gui.agentManage.justNow": "刚刚",
        "gui.agentManage.minutesAgo": "{minutes} 分钟前",
        "gui.agentManage.hoursMinutesAgo": "{hours} 小时 {minutes} 分钟前",
        "gui.agentManage.hoursAgo": "{hours} 小时前",
        "gui.agentManage.confirmDelete": "确定要删除该智能体吗？",
        "gui.agentManage.deleting": "删除中...",
        "gui.agentManage.deleteSuccess": "删除成功！",
        "gui.agentManage.deleteFailed": "删除失败！",
        "gui.agentManage.autoUpdateEnabled": "自动更新已启用",
        "gui.agentManage.autoUpdateDisabled": "自动更新已禁用",
        "gui.agentManage.operationFailed": "操作失败",
        "gui.agentManage.llmModel": "LLM模型：",
        "gui.agentManage.ttsModel": "TTS模型：",
        "gui.agentManage.configRole": "配置角色",
        "gui.agentManage.deviceManagement": "设备管理({count})",
        "gui.agentManage.enableMemoryFirst": "请先在'配置角色'中启用记忆功能",
        "gui.agentManage.chatHistory": "聊天历史",
        "gui.agentManage.recentConversation": "最近对话：{time}",
        "gui.agentManage.view": "查看",
        "gui.agentManage.createTime": "创建时间：{time}",
        "gui.agentManage.updateTime": "更新时间：{time}",
        "gui.agentManage.remarkUpdateSuccess": "备注更新成功",
        "gui.agentManage.remarkUpdateFailed": "备注更新失败",
        "gui.agentManage.teacherBind": "老师绑定",
        "gui.agentManage.getFirmwareTypeFailed": "获取固件类型失败",
        "gui.agentManage.unbinding": "解绑中...",
        "gui.agentManage.batchUnbindSuccess": "成功解绑{count}个设备",
        "gui.agentManage.batchUnbindError": "批量解绑时发生错误",
        "gui.agentManage.selectDeviceToUnbind": "请选择要解绑的设备",
        "gui.agentManage.confirmBatchUnbind": "确定要解绑选中的{count}个设备吗？",
        "gui.agentManage.confirmUnbindDevice": "确定要解绑设备\"{name}\"吗？",
        "gui.agentManage.deviceUnbindSuccess": "设备解绑成功",
        "gui.agentManage.deviceUnbindFailed": "设备解绑失败",
        "gui.agentManage.getDeviceListFailed": "获取设备列表失败",
        "gui.agentManage.updating": "更新中...",
        "gui.agentManage.adding": "添加中...",
        "gui.agentManage.deviceAddSuccess": "设备添加成功",
        "gui.agentManage.addFailed": "添加失败",
        "gui.agentManage.enter6DigitCode": "请输入6位验证码",
        "gui.agentManage.deviceBindSuccess": "设备绑定成功",
        "gui.agentManage.noData": "暂无数据",
        "gui.agentManage.verificationBind": "验证码绑定",
        "gui.agentManage.manualAdd": "手动添加",
        "gui.agentManage.manualAddDevice": "手动添加设备",
        "gui.agentManage.enterFirmwareVersion": "请输入固件版本",
        "gui.agentManage.macAddressFormat": "请输入正确的Mac地址格式，例：00:1A:2B:3C:4D:5E",
        "gui.agentManage.enterMacAddress": "请输入Mac地址",
        "gui.agentManage.verificationCode": "验证码",
        "gui.agentManage.enterVerificationCode": "请输入验证码！",
        "gui.agentManage.getPluginListFailed": "获取插件列表失败",
        "gui.agentManage.getTemplateListFailed": "获取模板列表失败",
        "gui.agentManage.getModelListFailed": "获取模型列表失败",
        "gui.agentManage.getLlmModelListFailed": "获取LLM模型列表失败",
        "gui.agentManage.getConfigFailed": "获取配置失败",
        "gui.agentManage.templateApplied": "已应用「{name}」模板",
        "gui.agentManage.confirmReset": "确定要重置配置吗？",
        "gui.agentManage.configSaveSuccess": "配置保存成功",
        "gui.agentManage.configSaveFailed": "配置保存失败",
        "gui.agentManage.configReset": "配置已重置",
        "gui.agentManage.roleVoice": "角色语音：",
        "gui.agentManage.voiceDescription": "角色语音是指不同平台可以支持的具体说话人声音,包括男声、女声、童声等",
        // DynamicFormFields
        "gui.agentManage.pleaseEnter": "请输入",
        "gui.agentManage.pleaseSelect": "请选择",
        "gui.agentManage.requiredField": "此项为必填项",
        "gui.agentManage.invalidFormat": "格式不正确",
        "gui.agentManage.addItem": "添加项",
        "gui.agentManage.remove": "移除",
        // AIConfigModal & AIConfigContent
        "gui.agentManage.aiConfig": "AI配置",
        "gui.agentManage.vad": "语音活动检测(VAD)",
        "gui.agentManage.asr": "语音识别(ASR)",
        "gui.agentManage.llm": "大语言模型(LLM)",
        "gui.agentManage.tts": "语音合成(TTS)",
        "gui.agentManage.memory": "记忆",
        "gui.agentManage.noMemory": "无记忆",
        "gui.agentManage.roleSetting": "角色设置",
        "gui.agentManage.systemPrompt": "系统提示词",
        "gui.agentManage.save": "保存",
        "gui.agentManage.saving": "保存中...",
        "gui.agentManage.saveSuccess": "保存成功",
        "gui.agentManage.saveFailed": "保存失败",
        "gui.agentManage.loadConfigFailed": "加载配置失败",
        "gui.agentManage.selectModel": "请选择模型",
        "gui.agentManage.configDescription": "配置AI模型参数和角色设置",
        "gui.agentManage.noToolsAvailable": "暂无可用工具",
        "gui.agentManage.pleaseEnterFirmwareVersion": "请输入固件版本！",
        "gui.agentManage.pleaseEnterMacAddress": "请输入 Mac 地址！",
        "gui.agentManage.macAddressRequired": "请输入 Mac 地址",
        // AI 配置相关
        "gui.agentManage.vllm": "视觉语言大模型 (VLLM)",
        "gui.agentManage.intent": "意图识别 (Intent)",
        "gui.agentManage.restartNotice": "保存配置后需要重启设备才能使新配置生效",
        "gui.agentManage.roleConfig": "角色配置",
        "gui.agentManage.saveConfig": "保存配置",
        "gui.agentManage.reset": "重置",
        "gui.agentManage.roleNickname": "角色昵称：",
        "gui.agentManage.roleTemplate": "角色模板：",
        "gui.agentManage.roleDescription": "角色描述：",
        "gui.agentManage.shortTermMemory": "对话短期记忆：",
        // Additional AI Configuration Fields
        "gui.agentManage.reportText": "报告文本",
        "gui.agentManage.reportTextVoice": "报告语音",
        "gui.agentManage.memoryRecommend": "记忆推荐",
        "gui.agentManage.ttsDescription": "语音合成 (TTS)",
        "gui.agentManage.confirmResetForm": "确定要重置表单吗？",
        "gui.agentManage.teacherRole": "授课老师",
        "gui.agentManage.teacherNote1": "注意：老师需要查看和解绑课堂上已经绑定给学生的设备",
        "gui.agentManage.teacherNote2": "注意：老师分配的设备不能解绑或编辑",
        "gui.agentManage.getFirmwareTypeError": "获取固件类型失败:",
        // Custom Fields - Image Upload
        "gui.customFields.uploaded": "已上传",
        "gui.customFields.uploadImage": "上传图片",
        "gui.customFields.invalidFileType": "请选择有效的图片文件",
        "gui.customFields.fileTooLarge": "图片大小不能超过 500KB\n当前大小：{size}KB\n请选择更小的图片",
        "gui.customFields.uploadFailed": "上传失败",
        "gui.customFields.uploadError": "图片上传失败：{error}",
        "gui.customFields.uploadRetry": "图片上传失败，请重试",
    });
}

addLocaleData(localeData);

const UPDATE_LOCALES = "scratch-gui/locales/UPDATE_LOCALES";
const SELECT_LOCALE = "scratch-gui/locales/SELECT_LOCALE";
// 统一的 cookie key，用于多个项目共享语言设置
const COOKIE_KEY = "language";

// 获取 cookie 值
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

// 设置 cookie
const setCookie = (name, value, days = 365) => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/';
};

// 获取浏览器语言
const getBrowserLocale = () => {
    const browserLang = (navigator.language || navigator.userLanguage || "").toLowerCase();
    // 中文环境判断
    if (browserLang.startsWith("zh")) {
        return "zh-cn";
    }
    // 默认英文
    return "en";
};

// 获取初始语言：cookie > 浏览器语言 > 默认英文
const getInitialLocale = () => {
    // 1. 先检查 cookie（与 course-ui 共享）
    const savedLocale = getCookie(COOKIE_KEY);
    if (savedLocale) {
        // 转换语言码格式
        if (savedLocale === "zh" || savedLocale === "zh-cn") return "zh-cn";
        if (savedLocale === "en") return "en";
    }
    
    // 2. 检测浏览器语言
    return getBrowserLocale();
};

// 保存语言设置到 cookie
const saveLocaleToStorage = (locale) => {
    // 统一保存为 course-ui 的格式
    const cookieValue = locale === "zh-cn" ? "zh" : "en";
    setCookie(COOKIE_KEY, cookieValue);
};

const initialLocale = getInitialLocale();

const initialState = {
    isRtl: isRtl(initialLocale),
    locale: initialLocale,
    messagesByLocale: filteredMessages,
    messages: filteredMessages[initialLocale] || filteredMessages.en,
};

const reducer = function (state, action) {
    if (typeof state === "undefined") state = initialState;
    switch (action.type) {
        case SELECT_LOCALE:
            return Object.assign({}, state, {
                isRtl: isRtl(action.locale),
                locale: action.locale,
                messagesByLocale: state.messagesByLocale,
                messages: state.messagesByLocale[action.locale],
            });
        case UPDATE_LOCALES:
            return Object.assign({}, state, {
                isRtl: state.isRtl,
                locale: state.locale,
                messagesByLocale: action.messagesByLocale,
                messages: action.messagesByLocale[state.locale],
            });
        default:
            return state;
    }
};

const selectLocale = function (locale) {
    // 保存到本地缓存
    saveLocaleToStorage(locale);
    return {
        type: SELECT_LOCALE,
        locale: locale,
    };
};

const setLocales = function (localesMessages) {
    return {
        type: UPDATE_LOCALES,
        messagesByLocale: localesMessages,
    };
};
const initLocale = function (currentState, locale) {
    if (
        Object.prototype.hasOwnProperty.call(
            currentState.messagesByLocale,
            locale
        )
    ) {
        return Object.assign({}, currentState, {
            isRtl: isRtl(locale),
            locale: locale,
            messagesByLocale: currentState.messagesByLocale,
            messages: currentState.messagesByLocale[locale],
        });
    }
    // don't change locale if it's not in the current messages
    return currentState;
};
export {
    reducer as default,
    initialState as localesInitialState,
    initLocale,
    selectLocale,
    setLocales,
};
